import React, { useEffect, useRef, useState } from "react";
import { Button, FormLabel, FormElement, FormInput, CancelButton } from "../../../../../components/StyledElements";
import swal from "sweetalert2";
import { updateFAQ } from "../../../../../services/courses";


export const EditFAQ = ({ levelSection, onUpdateFAQ = () => { }, style = {} }) => {

  console.log("!!! FAQ GROUPS: ", levelSection.faq_groups);
  const containerRef = useRef(null);
  const questionContainerRefs = useRef([]);

  const [currentFAQGroupIndex, setCurrentFAQGroupIndex] = useState(0);
  const [currentFAQGroup, setCurrentFAQGroup] = useState();
  const [updatedFAQGroup, setUpdatedFAQGroup] = useState();
  const [currentFAQQuestionIndex, setCurrentFAQQuestionIndex] = useState(0);
  const [currentFAQQuestion, setCurrentFAQQuestion] = useState();
  const [updatedFAQQuestion, setUpdatedFAQQuestion] = useState();
  const [savingFAQ, setSavingFAQ] = useState(false);
  //
  //
  //  
  useEffect(() => {
    const r = window.addEventListener("resize", () => {
      if (containerRef.current) {
        const newContainerWidth = containerRef.current.getBoundingClientRect().width;
        const offset = (currentFAQGroupIndex + 1) * (newContainerWidth + 10);
        containerRef.current.scrollTo({ left: offset, behavior: "smooth" });
      }
    });

    return () => {
      window.removeEventListener("resize", r);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    // Get the current hash from the URL and set the current faq_group accordingly
    if (!levelSection?.faq_groups || levelSection.faq_groups.length === 0) {
      return;
    }

    const hash = window.location.hash;
    const parts = hash.split("&");
    console.log("!!! pARTS: ", parts);
    if (parts.length > 0 && parts[0] === "#faq") {
      if (parts && parts.length > 1) {
        const faq_groupIndex = parseInt(parts[1]);
        console.log("!!! faq_group INDEX: ", faq_groupIndex);
        if (!isNaN(faq_groupIndex) && faq_groupIndex > 0 && faq_groupIndex <= levelSection?.faq_groups?.length) {
          setCurrentFAQGroupIndex(faq_groupIndex - 1);
          const offset = (faq_groupIndex - 1) * (containerRef.current.getBoundingClientRect().width + 10);
          containerRef.current.scrollTo({ left: offset });
        }
      } else {
        window.history.replaceState(null, null, `#faq&1`);
        setCurrentFAQGroupIndex(0);
        containerRef.current.scrollTo({ left: 0 });
      }
    }
  }, [levelSection?.faq_groups]);

  useEffect(() => {
    if (!levelSection?.faq_groups || levelSection.faq_groups.length === 0) {
      return;
    }

    const currentGroup = levelSection.faq_groups[currentFAQGroupIndex];
    setCurrentFAQGroup(currentGroup);
    setUpdatedFAQGroup({ ...currentGroup });

    if (!currentGroup?.questions || currentGroup.questions.length === 0) {
      return;
    }

    const currentQuestion = currentGroup.questions[currentFAQQuestionIndex];
    setCurrentFAQQuestion(currentQuestion);
    setUpdatedFAQQuestion({ ...currentQuestion });

  }, [levelSection?.faq_groups, currentFAQGroupIndex, currentFAQQuestionIndex]);

  const hasChanged = () => {
    if (!currentFAQQuestion || !updatedFAQQuestion) {
      return false;
    }

    return currentFAQQuestion.question !== updatedFAQQuestion.question ||
      currentFAQQuestion.answer !== updatedFAQQuestion.answer ||
      currentFAQGroup.title !== updatedFAQGroup.title;
  }

  return (
    <div style={{ display: "flex", flexDirection: "column", ...style }}>
      <div style={{ position: "absolute", top: 20, right: 20, display: "flex", zIndex: 200, flexDirection: "row", gap: "10px" }}>
        <CancelButton onClick={() => {
          swal.fire({
            title: "Are you sure?",
            text: "Any unsaved changes will be lost.",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes, cancel",
            cancelButtonText: "No, keep editing",
          }).then((result) => {
            console.log("!!! RESULT: ", result);
            if (result?.value) {
              setUpdatedFAQQuestion(currentFAQQuestionIndex);
            }
          });
        }}>Cancel</CancelButton>
        <Button disabled={!hasChanged() || savingFAQ} style={{ marginLeft: "auto" }}
          onClick={async () => {
            if (!hasChanged()) {
              return;
            }


            // open a sweetalert2 modal until the save is complete
            swal.fire({
              title: "Saving...",
              text: "Please wait while the content block is being saved.",
              allowOutsideClick: false,
              didOpen: () => {
                swal.showLoading();
              },
            });

            setSavingFAQ(true);
            const results = await updateFAQ(updatedFAQGroup, updatedFAQQuestion);
            setSavingFAQ(false);

            if (results.success) {
              //const newUpdatedBlock = results.content_block;
              setCurrentFAQGroup(updatedFAQGroup);
              setCurrentFAQQuestion(updatedFAQQuestion);
              onUpdateFAQ({ group: { ...results.group }, question: { ...results.question } });

              swal.fire({
                title: "Success",
                text: "Content block saved successfully.",
                icon: "success",
              });
            } else {
              swal.fire({
                title: "Error",
                text: results.error || "An error occurred while saving the content block.",
                icon: "error",
              });
            }
          }}
        >
          {savingFAQ ? "Saving FAQ..." : "Save FAQ"}
        </Button>
      </div>
      <FormLabel label={`FAQ Group ${currentFAQGroupIndex + 1} of ${levelSection?.faq_groups?.length}`} />

      <FormElement>
        <FormInput value={levelSection?.faq_groups?.[currentFAQGroupIndex]?.public_id ?? ""} style={{ backgroundColor: "white" }} disabled />
      </FormElement>

      <FormElement>
        <FormInput value={updatedFAQGroup?.title ?? ""}
          onChange={(e) => {
            setUpdatedFAQGroup({ ...updatedFAQGroup, title: e.target.value });

          }}
        />
      </FormElement>

      <FormLabel label={`FAQ Group Questions ${currentFAQQuestionIndex + 1} of ${levelSection?.faq_groups?.[currentFAQGroupIndex]?.questions?.length}`} style={{ marginTop: "20px", marginBottom: "-20px" }} />
      <div ref={containerRef} id="content-faq_groups-container" style={{ width: "100%", marginBottom: "10px", overflow: "hidden" }}>
        <div style={{ display: "flex", flexDirection: "row", marginBottom: "10px", flowWrap: "nowrap" }}>
          {/*Each content faq_group will be displayed as it's own page, and the wrapper will scroll horizontally to show the next contenhg faq_group*/}
          {levelSection?.faq_groups?.map((faq_group, index) => (
            <div key={index} style={{ flex: "0 0 100%", marginRight: "10px", display: "flex", flexDirection: "column" }}>
              <div ref={(ref) => questionContainerRefs.current[index] = ref} id="content-faq-group-questions-container" style={{ width: "100%", marginBottom: "10px", overflow: "hidden" }}>
                <div style={{ display: "flex", flexDirection: "row", marginBottom: "10px", flowWrap: "nowrap" }}>
                  {faq_group?.questions?.map((question, qIndex) => {
                    const isCurrent = qIndex === currentFAQQuestionIndex && index === currentFAQGroupIndex;
                    const faqQuestion = isCurrent ? updatedFAQQuestion : question;

                    return (
                      <div key={qIndex} style={{ flex: "0 0 100%", marginRight: "10px", display: "flex", flexDirection: "column" }}>
                        <FormElement key={qIndex} style={{ marginTop: "30px" }}>
                          <FormInput
                            value={faqQuestion?.public_id ?? ""}
                            style={{ width: "100%", marginBottom: "10px", backgroundColor: "white" }}
                            readOnly={true}
                          />
                          <FormInput
                            value={faqQuestion?.question ?? ""}
                            readOnly={!isCurrent}
                            style={{ width: "100%", marginBottom: "10px" }}
                            onChange={isCurrent ? (e) => {
                              setUpdatedFAQQuestion({ ...updatedFAQQuestion, question: e.target.value });
                            } : null}
                          />
                          <FormInput
                            as="textarea"
                            value={faqQuestion?.answer ?? ""}
                            readOnly={!isCurrent}
                            style={{ width: "100%", height: "200px", resize: "vertical" }}
                            onChange={isCurrent ? (e) => {
                              setUpdatedFAQQuestion({ ...updatedFAQQuestion, answer: e.target.value });
                            } : null}
                          />
                        </FormElement>
                      </div>
                    )
                  })}
                </div>
              </div>
              <div style={{ width: "100%", display: "flex", flexDirection: "row" }}>
                {currentFAQQuestionIndex > 0 ? (
                  <Button style={{ justifySelf: "flex-start" }} onClick={() => {
                    const width = containerRef.current.getBoundingClientRect().width;
                    const offset = (currentFAQQuestionIndex - 1) * (width + 10);
                    setCurrentFAQQuestionIndex(currentFAQQuestionIndex - 1);
                    questionContainerRefs.current[index].scrollTo({ left: offset, behavior: "smooth" });
                  }}>Previous Question</Button>
                ) : null}
                {
                  currentFAQQuestionIndex < faq_group?.questions?.length - 1 ? (
                    <Button style={{ justifySelf: "flex-end", marginLeft: "auto" }} onClick={() => {
                      const width = containerRef.current.getBoundingClientRect().width;
                      const offset = (currentFAQQuestionIndex + 1) * (width + 10);

                      setCurrentFAQQuestionIndex(currentFAQQuestionIndex + 1);
                      console.log("!!! QUESTION CONTAINER REFS: ", questionContainerRefs);
                      questionContainerRefs.current[index].scrollTo({ left: offset, behavior: "smooth" });
                      // Update the current url hash to reflect the current content faq_group
                    }}>Next Question</Button>) : null}
              </div>
            </div>
          ))}
        </div>
      </div>
      <div style={{ width: "100%", display: "flex", flexDirection: "row" }}>
        {currentFAQGroupIndex > 0 ? (
          <Button style={{ justifySelf: "flex-start" }} onClick={() => {
            const width = containerRef.current.getBoundingClientRect().width;
            const offset = (currentFAQGroupIndex - 1) * (width + 10);
            setCurrentFAQGroupIndex(currentFAQGroupIndex - 1);
            setCurrentFAQQuestionIndex(0);
            containerRef.current.scrollTo({ left: offset, behavior: "smooth" });
            window.history.replaceState(null, null, `#faq&${currentFAQGroupIndex - 1}`);
          }}>Previous Group</Button>
        ) : null}
        {
          currentFAQGroupIndex < levelSection?.faq_groups?.length - 1 ? (
            <Button style={{ justifySelf: "flex-end", marginLeft: "auto" }} onClick={() => {
              const width = containerRef.current.getBoundingClientRect().width;
              const offset = (currentFAQGroupIndex + 1) * (width + 10);
              setCurrentFAQGroupIndex(currentFAQGroupIndex + 1);
              setCurrentFAQQuestionIndex(0);
              containerRef.current.scrollTo({ left: offset, behavior: "smooth" });
              // Update the current url hash to reflect the current content faq_group
              window.history.replaceState(null, null, `#faq&${currentFAQGroupIndex + 2}`);
            }}>Next Group</Button>) : null}
      </div>
    </div >
  )
}

export default EditFAQ;
